import * as z from "zod";

export const getWalmartIntegration = {
  name: "getWalmartIntegration" as const,
  input: z.object({}),
  output: z.object({
    exists: z.boolean(),
    enabled: z.boolean().optional(),
    valid: z.boolean().optional(),
  }),
};
